import React, { useRef } from "react";
import Widthcontainer from "../../components/customcomponents/widthcontainer";
import BlogPostCard from "./BlogPostCard.js";

export default function BlogSection({ data }) {
   return (
      <Widthcontainer className={"home__blogSection"}>
         <div className="fixed-width">
            <h4 className="blog__heading">Our Blogs</h4>
            <div className="blogPost__wrapper">
               {Object.entries(data)?.map(([key, value]) => {
                  return <BlogPostCard data={value} />;
               })}
            </div>
         </div>
      </Widthcontainer>
   );
}
